export const colors = {
  red: '#ff0000',
  blue: '#0077be',
  yellow: '#d8f52b',
  white: '#ffffff',
  black: '#000000',
  dark: '#2b2e42',
  gray100: '#f9f9fa', // hover item
  gray200: '#e4e7eC', // selected item
  gray300: '#d6d6d6', // numOfCar == 0
  gray400: '#7f7f7f', // numOfCar != 0
  grey: '#D8D8D8',
  border: '#979797',
  background: 'rgba(242, 242, 242, 0.6)',
  hover: 'rgba(216, 245, 35, 0.4)',
  area: '#4d5060',
  area_selected: '#084ba3',
  area_outside: 'red',
  equipment_ready: '#7f7f7f',
  equipped: '#7f7f7f',
  removed: '#9F9F9F',
  terminated: '#9F9F9F',
  release_ready: '#2b2e42',
  released: '#2f2e2e',
  blocked: '#ee4e4e',
  rented: '#d8f52b',
  device: {
    online: '#0AB735',
    offline: '#ee4e4e',
  },
  cares: {
    closed: '#0AB735',
    inProgress: '#F5A623',
    open: '#9F9F9F',
    planned: '#9F9F9F',
  },
  trips: {
    cancelled: '#9F9F9F',
    finished: '#0AB735',
    inProgress: '#F5A623',
    reserved: '#1588E0',
  },
  bookings: {
    waiting: '#DDDDDD',
    offered: '#1588E0',
    confirmed: '#F5A623',
    started: '#0AB735',
    finished: '#0AB735',
    cancelled: '#9F9F9F',
  },
  claim: {
    open: '#ee4e4e', // red
    pending: '#4a90e2',
    inProgress: '#f5a623', // orange
    closed: '#0AB735', // grey
    closedSettled: '#0ab735', // green
  },
  // colors from figam
  navMenuBgDeep: '#000000',
  navMenuBgMain: '#333333',
  navMenuBgLight: '#5B5B5B',
  navMenuTypoHeadline: '#A3A3A3',
  backgroundContentMain: '#F2F2F2',
  backgroundContentLight: '#FFFFFF',
  buttonActive: '#333333',
  buttonDisabled: '#DDDDDD',
  buttonTypoDisabled: '#C7C7C7',
  getawayGreen: '#B7F051',
  getawayNeon: '#D8F523',
  getawayDarkNeon: '#A2AD00',
  getawayGradient: 'linear-gradient(225deg, #D8F523 0%, #B7F051 100%)',
  statusSuccess: '#0AB735',
  statusProgress: '#F5A623',
  statusAlert: '#EE4E4E',
  statusNeutral: '#C7C7C7',
  interactiveLink: '#0077BE',
  editorAccent: '#1677ff',
  highlight: {
    selected: 'rgba(216, 245, 35, 0.4)',
    hovered: 'rgba(216, 245, 35, 0.1)',
  },
};

export const fleetStyleColors: Record<string, string> = {
  obi: '#ff7e21',
  expert: '#FF5E19',
  spp: '#2d2d2d',
  bub: '#e3000f',
  zhero: '#36D1E8',
  jysk: '#143C8A',
  luckyCar: '#FFE500',
};

export const fleetStyleLightColors: Record<string, string> = {
  obi: 'rgba(255,126, 33,0.1)',
  expert: 'rgba(255,126, 33,0.1)',
  spp: 'rgba(45,45, 45,0.1)',
  bub: 'rgba(227,0, 15,0.1)',
  zhero: 'rgba(54, 209, 232,0.1)',
  jysk: 'rgba(20, 60, 138,0.1)',
  luckyCar: 'rgba(255, 229, 0,0.1)',
};

export const brandColors: Record<string, string> = {
  '000000000000000000000002': '#00c4d1', // UBQ
  '5ef1f2e4c8f48f0f7912d487': '#fac500', // MSM
  '6329b7e9448df21336278b69': '#1a6c7a', // MBA staging
  '631b10eb46d0600e4545bb18': '#1a6c7a', // MBA
  '68db99e99c525855188c70a1': '#e3000f', // BUB staging
  '68d2b8cdfc85d1466c5a0a29': '#e3000f', // BUB
  '6a8ee1b65e3d7c01576f6bf7': '#009900', // EPC staging
  '6a96f47d1b150f66bceda2eb': '#009900', // EPC
};

export const brandLightColors: Record<string, string> = {
  '000000000000000000000002': 'rgba(0, 196, 209, 0.13)',
  '5ef1f2e4c8f48f0f7912d487': 'rgba(250, 197, 0, 0.13)',
  '6329b7e9448df21336278b69': 'rgba(26, 108, 122,0.1)',
  '631b10eb46d0600e4545bb18': 'rgba(26, 108, 122,0.1)',
  '68db99e99c525855188c70a1': 'rgba(227, 0, 15,0.1)',
  '68d2b8cdfc85d1466c5a0a29': 'rgba(227, 0, 15,0.1)',
  '6a8ee1b65e3d7c01576f6bf7': 'rgba(0, 153, 0,0.1)',
  '6a96f47d1b150f66bceda2eb': 'rgba(0, 153, 0,0.1)',
};

export const zIndex = {
  notesBar: 0,
  notesCircle: 1,
  carMarker: 3,
  carMarkerSelected: 4,
  appliedFilterTag: 5,
  header: 999,
  addFilter: 1000,
  columnSelector: 1000,
  addFilterCloseButton: 1001,
  columnSelectorCloseButton: 1001,
  widget: 1000,
  carDrawerCloseButton: 1001 /* ant-drawer z-index is 1000 */,
  damageModal: 1001,
  allAroundModal: 1001,
  logoutModal: 1001,
  autoCompletePopup: '1301 !important',
  drawer: 1300,
  drawerDesktop: 1300,
  annotateModal: 1400,
  dropDown: 2000,
};

export const common = {
  deepShadow: 'box-shadow: 0px 2px 50px rgba(0, 0, 0, 0.268985);',
  secondaryShadow: 'box-shadow: 0 4px 10px 0 #0000004c;',
  button: `width: 100%;
  font-size: 16px;
  margin: 8px 0;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  display: block;`,
  submitButton: `color: #fff;
  background: #313131;
  display: flex;
  justify-content: center;
  border: 0;`,
  cancelButton: `color: #313131;
  display: flex;
  justify-content: center;
  border: 2px solid #313131;`,
  discardButton: `color: red !important;
  font-weight: bold;
  display: flex;
  justify-content: center;
  background-color: #ededed !important;
  border: 1px solid lightgrey !important;`,
  checkbox: `background: #2f2e2e;
  border-color: #f5f5f5;`,
  checkboxDisabled: `background: #cccdd0;`,
  panelMaxHeight: (offset = 0) =>
    `max-height: calc(100vh - ${232 + offset}px);`,
};
